import CacheBase2 from '../../../services/engines/CacheBase2';

class CsCodeTemplateCache extends CacheBase2 {
    initialize() {
        this._name = 'CsCodeTemplateCache';
    }
}

const csCodeTemplateCache = new CsCodeTemplateCache();
export default csCodeTemplateCache;
